/**
 * SHARED LEGACY FILE
 *
 * These account utilities are used by multiple apps split from LearningCenterUI.
 * They do not belong to any single app — each app that needs them
 * imports this shared copy.
 *
 * The .legacy suffix exists to preserve git history transfer.
 */

export const INTERNAL_PORTAL_ID = 137828;
export const INTERNAL_PORTAL_ID_QA = 885765335;
export const GENERATION_PORTAL_ID = 50619635;
export const GENERATION_PORTAL_ID_QA = 911635575;
export const ACADEMY_LABS_SOURCE_PORTAL_ID = 50958693;
export const ACADEMY_LABS_SOURCE_PORTAL_ID_QA = 913439751;